import { TagRootProps } from '@chakra-ui/react';
import { ContractEndActionEnum, ContractStatusEnum } from '@monetize/types/app';
import { FilterTypeOperator } from '@monetize/types/common';
import { objectToObjArray } from '../utils/misc';
import { NEW_CONTRACT_SLUG } from './quotes';

export const CONTRACT_STATUS_DISPLAY: {
  [key in ContractStatusEnum]: string;
} = {
  ACTIVE: 'Active',
  CANCELED: 'Canceled',
  PENDING: 'Pending',
  FINISHED: 'Finished',
};

export const CONTRACT_PENDING_STATUS_TOOLTIP =
  'Your contract is pending because the first invoice of the renewal contract has not yet been generated, or invoice generation is set to manual. Progress invoicing if you want to move the contract to an active status.';

export const CONTRACT_CANCELED_RENEWAL_MESSAGE =
  'Canceled Contracts cannot be renewed.  Instead, create a New Quote.';

export const CONTRACT_STATUS_TAG_VARIANT: {
  [key in ContractStatusEnum]: TagRootProps['variant'];
} = {
  ACTIVE: 'green',
  PENDING: 'outline',
  FINISHED: 'gray',
  CANCELED: 'red',
};

/** Accent used for status bars and dots in contract lineage views */
export const CONTRACT_STATUS_ACCENT_COLOR: {
  [key in ContractStatusEnum]: string;
} = {
  ACTIVE: 'tGreen.mDarkShade',
  // The purple used for renewal tags; pending terms are usually renewals
  PENDING: 'tMagenta.base',
  FINISHED: 'border.strong',
  CANCELED: 'tRed.base',
};

export const CONTRACT_END_ACTION_DISPLAY: {
  [key in ContractEndActionEnum]: string;
} = {
  RENEW: 'Auto Renew',
  MANUAL_RENEW: 'Renewal',
  CANCEL: 'Cancel',
};

export const CONTRACT_END_ACTION_UI_DISPLAY: {
  [key in ContractEndActionEnum]: string;
} = {
  RENEW: 'Auto Renew',
  MANUAL_RENEW: 'Renewal',
  CANCEL: 'No Auto Renew',
};

/** What follows the end date in contract lineage views, e.g. "Ends Jun 1, 2027, then auto-renews" */
export const CONTRACT_LINEAGE_END_ACTION_OUTCOME: {
  [key in ContractEndActionEnum]: string;
} = {
  RENEW: 'then auto-renews',
  MANUAL_RENEW: 'then renews manually',
  CANCEL: 'does not auto-renew',
};

export const CONTRACT_STATUS_FILTER_ITEMS = objectToObjArray(
  CONTRACT_STATUS_DISPLAY,
  'value',
  'label',
);

export const CONTRACT_STATUS_FILTER_OPTION = {
  title: 'Status',
  key: 'status',
  operator: FilterTypeOperator.IN,
  items: CONTRACT_STATUS_FILTER_ITEMS,
};

export const NEW_CONTRACT_OPTION = {
  contractName: '+ New Contract',
  id: NEW_CONTRACT_SLUG,
};

export const CONTRACT_END_ACTION_FILTER_OPTION = {
  title: 'Renewal Action',
  key: 'endAction',
  operator: FilterTypeOperator.IN,
  items: objectToObjArray(
    CONTRACT_END_ACTION_UI_DISPLAY,
    'value',
    'label',
  ).filter((item) => item.value !== 'MANUAL_RENEW'),
};

export const CONTRACT_STATUS_AMEND_ALLOWED = new Set([
  ContractStatusEnum.ACTIVE,
  ContractStatusEnum.PENDING,
  ContractStatusEnum.CANCELED,
]);

export const CONTRACT_STATUS_RENEWAL_ALLOWED = new Set([
  ContractStatusEnum.ACTIVE,
  ContractStatusEnum.PENDING,
  ContractStatusEnum.FINISHED,
]);

export const CONTRACT_STATUS_CANCEL_ALLOWED = new Set([
  ContractStatusEnum.ACTIVE,
  ContractStatusEnum.PENDING,
]);
